import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { _userProfileData } from "../../components/https/settings/profileSettings";
import { _addUserProfileData } from "../../redux/actions/profileSettingsAction";

export const useUserProfileRefresher = () => {
  const dispatch = useDispatch();
  const isLoggin = useSelector((state) => state.auth.isLoggin);

  useEffect(() => {
    if (!isLoggin) return; // only run when logged in
    const fetchProfile = async () => {
      try {
        const response = await _userProfileData();
        if (response.status === 200) {
          dispatch(_addUserProfileData(response.data.data));
          localStorage.setItem("user", JSON.stringify(response.data.data));
        }
      } catch (error) {
        console.log("error>>>>>>>>>>>>>>>", error);
      }
    };

    fetchProfile(); // initial call

    const intervalId = setInterval(fetchProfile, 5 * 60 * 1000); // every 1 min

    return () => clearInterval(intervalId);
  }, [dispatch]);
};
